import type { Components, Theme } from "@mui/material/styles";

export const MuiInput: Components<Theme>["MuiInput"] = {
  defaultProps: {
    disableUnderline: true,
  },
};
